import mixin from '@/mixin/index.js';

import ideal_weight from "@/calculators/ideal_weight.calculators.js";
import iris from "@/calculators/iris.calculators.js";
import dose from "@/calculators/dose.calculators.js";
import ruleOfThree from "@/calculators/rule_of_three.calculators.js";
import transfusionCalculators from "@/calculators/transfusion.calculators.js";
const {
    transfusionBloodVolumeAndSpeed,
    transfusionBloodVolume,
    donorMaximumBloodVolume
} = transfusionCalculators;
import calculatorLabels from "@/constants/labels/calculators.labels.js";
import BigNumber from "bignumber.js";
const _formatNumber = mixin.methods._formatNumber;
const _roundNumber = mixin.methods._roundNumber;
import fluidTherapy from "@/calculators/fluid_therapy.calculators.js";
const {
    simpleFluidTherapy
} = fluidTherapy;
import drip from "@/calculators/drip.calculators.js";
const {
    volumeToDrops, dropsToVolume
} = drip;

export default Object.freeze([
    volumeToDrops,
    dropsToVolume,
    simpleFluidTherapy,
    ideal_weight,
    iris,
    dose,
    ruleOfThree,
    transfusionBloodVolumeAndSpeed,
    transfusionBloodVolume,
    donorMaximumBloodVolume,
    /* #region Conversão de Peso */
    {
        name: 'Conversão de Pesos',
        id: '813d534663204911a17fd39f08d49fbe',
        classes: ['Calculadoras de Conversão'],
        variables: [
            {
                name: 'Selecione a medida de Peso Inicial',
                type: 'select',
                placeholder: 'Selecione',
                id: 'unit',
                items: [
                    'quilogramas (kg)',
                    'gramas (g)',
                    'miligramas (mg)',
                    'microgramas (mcg)',
                    'nanogramas (ng)',
                ],
                default: null
            },
            {
                name: 'Digite o peso inicial',
                type: 'number',
                placeholder: 'Peso',
                id: 'weight',
                default: 0,
                displayUnit: 'unit'
            }
        ],
        calculate: function ({ unit, weight }) {
            weight = weight || '0';
            if (!unit) {
                return null;
            }
            weight = new BigNumber(weight.replace(',', '.'));
            const units = {
                'quilogramas (kg)': 1000,
                'gramas (g)': 1,
                'miligramas (mg)': 0.001,
                'microgramas (mcg)': 0.000001,
                'nanogramas (ng)': 0.000000001,
            };
            let response = [];
            for (const key in units) {
                let value = weight.times(units[unit]).dividedBy(units[key]);
                response.push(`${_formatNumber(value)} ${key}`);
            }
            return { type: 'array', values: response };
        },
        responseLabel: "Resultados",
        sections: [
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Calculadora utilizada com o intuito de converter diferentes unidades de medida de massa."
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Os resultados lhe mostrarão a conversão em diversas unidades de medida de massa, facilitando o seu dia a dia."
                                    }
                                ],
                                "description": "Basta selecionar a medida inicial de massa e digitar o valor desejado."
                            }
                        ]
                    }
                ],
                "description": "Objetivos da Calculadora "
            },
            {
                "description": "Indicações de Uso ",
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Conversão de unidades de medida de massa."
                            }
                        ]
                    }
                ]
            },
            {
                "description": "Interpretação ",
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Os resultados correspondem à conversão do valor digitado inicial."
                            }
                        ]
                    }
                ]
            }
        ],
        references: [
            {
                "magazine": "Livro",
                "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
                "link": "Não se aplica",
                "year": "2016",
                "level": "Não se aplica"
            },
            {
                "link": "Não se aplica",
                "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition",
                "level": "Não se aplica",
                "magazine": "Livro",
                "year": "2019"
            },
            {
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "link": "Não se aplica",
                "magazine": "Livro",
                "level": "Não se aplica",
                "year": "2019"
            }
        ]

    },
    /* #endregion */
    /* #region Cálculo de Superfície Corporal */
    {
        name: 'Cálculo de Superfície Corporal',
        id: '0d28048c89e943d7ae9ecdfb009014a3',
        classes: ['Calculadoras de Conversão'],
        variables: [
            {
                name: 'Selecione o paciente',
                type: 'select-animal',
                placeholder: 'Selecione',
                id: 'animal',
                items: [
                    'dog',
                    'cat',
                ],
                default: 0
            },
            {
                name: 'Peso em quilogramas',
                type: 'number',
                placeholder: 'Peso',
                id: 'weight',
                default: 0,
                suffix: 'kg'
            }
        ],
        calculate: function ({ animal, weight }) {
            const formulas = [
                /* Dogs */
                function (weight) {
                    return `${0.101 * Math.pow(weight, 0.66666667)}`;
                },
                /* Cats */
                function (weight) {
                    return `${0.1 * Math.pow(weight, 0.66666667)}`;
                }
            ]
            weight = weight || '0';
            weight = new Number(weight.replace(',', '.'));
            return _formatNumber(_roundNumber(formulas[animal](weight), 3));
        },
        responseLabel: "Área de Superfície Corporal em m²",
        sections: [
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "A dose da maioria dos agentes antineoplásicos e alguns outros agentes, é comumente baseada na área de superfície corporal (mg/metro quadrado) ao invés do peso (massa) da paciente (mg/kg)."
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Padronização em metros quadrados a fim de normalizar a nomenclatura no meio oncológico."
                                    },
                                    {
                                        "description": "Agentes antineoplásicos possuem uma estreita margem terapêutica, diante disso, doses em mg/kg podem levar a sobredosagens mais facilmente, quando comparado à dose baseada em metros quadrados. "
                                    },
                                    {
                                        "description": "Estudos alométricos indicam que processos fisiológicos que influenciam na dinâmica do medicamento, tem uma maior correlação com a superfície corporal, sendo assim, a dose baseada em metros quadrados tende a ter maior acurácia. "
                                    }
                                ],
                                "description": "Diante do supracitado, podem surgir dúvidas sobre o real motivo dos cálculos de doses diferirem para os agentes antineoplásicos, listamos abaixo alguns pontos:"
                            },
                            {
                                "description": "Atenção:",
                                "objects": [
                                    {
                                        "description": "Algumas fontes (Veterinary Pharmacology and Therapeutics, 10th Edition;Small Animal Clinical Pharmacology and Therapeutics 2nd Edition) alertam que em pacientes com menos de 10 kg, deve-se ter cuidado redobrado diante do risco de sobredosagem, podendo-se até considerar o cálculo baseado no peso corporal. "
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "description": "O que é?"
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Calcular a área de superfície corporal do paciente baseada no peso.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "Objetivo da Calculadora "
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Cálculos de doses de agentes antineoplásicos."
                            },
                            {
                                "description": "As doses de agentes como a Prednisona/Prednisolona podem ocasionalmente serem dispostas em mg/metro quadrado.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "Indicações de Uso "
            }
        ],
        references: [
            {
                "year": "2018",
                "name": "Veterinary Pharmacology and Therapeutics, 10th Edition",
                "magazine": "Livro",
                "link": "Não se aplica",
                "level": "Não se aplica"
            },
            {
                "name": "BSAVA Small Animal Formulary, 10th Edition",
                "link": "Não se aplica",
                "magazine": "Livro",
                "level": "Não se aplica",
                "year": "2020"
            },
            {
                "name": "Small Animal Clinical Pharmacology and Therapeutics 2nd Edition",
                "magazine": "Livro",
                "year": "2011",
                "level": "Não se aplica",
                "link": "Não se aplica"
            },
            {
                "magazine": "Livro",
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "level": "Não se aplica",
                "link": "Não se aplica",
                "year": "2019"
            },
            {
                "year": "2019",
                "link": "Não se aplica",
                "magazine": "Livro",
                "name": "Withrow and MacEwen's Small Animal Clinical Oncology 6th Edition",
                "level": "Não se aplica"
            },
            {
                "level": "Não se aplica",
                "link": "Não se aplica",
                "year": "2018",
                "magazine": "Livro",
                "name": "Plumb's Veterinary Drug Handbook, 9th Edition"
            }
        ],
    },
    /* #endregion */
    /* #region Coma - Escala de Glasgow Modificada */
    {
        name: 'Coma - Escala de Glasgow Modificada',
        id: 'a8fe63e8461b4664bd3a18b56286b5a3',
        classes: ['Escalas | Escores'],
        premium: true,
        type: 'score',
        variables: [
            {
                name: 'Atividade Motora',
                type: 'checklist',
                id: 'motorActivity',
                items: [
                    { description: 'Marcha ou reflexos normais.', descriptionValue: '[6]', value: 6 },
                    { description: 'Hemiparesia, tetraparesia ou atividade descerebrada.', descriptionValue: '[5]', value: 5 },
                    { description: 'Decúbito, rigidez extensora intermitente.', descriptionValue: '[4]', value: 4 },
                    { description: 'Decúbito, rigidez extensora constante.', descriptionValue: '[3]', value: 3 },
                    { description: 'Decúbito, rigidez extensora constante e Opistótono.', descriptionValue: '[2]', value: 2 },
                    { description: 'Decúbito, músculos hipotônicos, reflexos reduzidos ou ausentes.', descriptionValue: '[1]', value: 1 },
                ],
                default: null
            },
            {
                name: 'Reflexos do tronco encefálico:',
                type: 'checklist',
                id: 'brainstemReflexes',
                items: [
                    { description: 'Reflexo pupilar fotomotor e oculocefálico normais.', descriptionValue: '[6]', value: 6 },
                    { description: 'Reflexo pupilar fotomotor lento, reflexos oculocefálicos normais a reduzidos.', descriptionValue: '[5]', value: 5 },
                    { description: 'Miose bilateral não responsiva, reflexos oculocefálicos normais a reduzidos.', descriptionValue: '[4]', value: 4 },
                    { description: 'Pupilas puntiformes, reflexos oculocefálicos reduzidos a ausentes.', descriptionValue: '[3]', value: 3 },
                    { description: 'Midríase unilateral não responsiva, reflexos oculocefálicos reduzidos a ausentes.', descriptionValue: '[2]', value: 2 },
                    { description: 'Midríase bilateral não responsiva, reflexos oculocefálicos reduzidos a ausentes.', descriptionValue: '[1]', value: 1 },
                ],
                default: null
            },
            {
                name: 'Nível de consciência:',
                type: 'checklist',
                id: 'consciousnessLevel',
                items: [
                    { description: 'Períodos ocasionais de alerta e responsivo ao ambiente.', descriptionValue: '[6]', value: 6 },
                    { description: 'Depressão ou delírio, capaz de responder, mas a resposta pode ser inapropriada.', descriptionValue: '[5]', value: 5 },
                    { description: 'Obnubilado, responsivo aos estímulos visuais.', descriptionValue: '[4]', value: 4 },
                    { description: 'Obnubilado, responsivo aos estímulos auditivos.', descriptionValue: '[3]', value: 3 },
                    { description: 'Estuporoso, responsivo aos estímulos nocivos.', descriptionValue: '[2]', value: 2 },
                    { description: 'Comatoso, não responsivo a reiterados estímulos nocivos.', descriptionValue: '[1]', value: 1 },
                ],
                default: null
            }
        ],
        calculate: function ({ motorActivity, brainstemReflexes, consciousnessLevel }) {
            let response = '';
            if (typeof motorActivity == 'number' && typeof brainstemReflexes == 'number' && typeof consciousnessLevel == 'number') {
                const sum = motorActivity + brainstemReflexes + consciousnessLevel;
                response = { type: 'class', value: "Valor: ", class: '' };
                if (sum >= 15) {
                    response.value += `${sum} - Prognóstico Bom`;
                    response.class = 'green lighten-4';
                } else if (sum >= 9) {
                    response.value += `${sum} - Prognóstico Reservado`;
                    response.class = 'yellow lighten-4';
                } else {
                    response.value += `${sum} - Prognóstico Ruim`;
                    response.class = 'red lighten-4';
                }
            }
            return response;
        },
        responseLabel: 'Resultado',
        sections: [
            {
                "objects": [
                    {
                        "description": "Avaliação Neurológica ",
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Permite avaliar o status neurológico inicial do paciente."
                                    },
                                    {
                                        "description": "Avaliações seriadas podem dar uma estimativa de melhora ou agravamento do quadro neurológico."
                                    },
                                    {
                                        "description": "Indicadores de melhora ou agravamento do quadro permitem o melhor direcionamento terapêutico do paciente."
                                    }
                                ],
                                "description": "A avaliação neurológica periódica e seriada em pacientes sujeitos a traumas cranioencefálicos é de suma importância pelos seguintes aspectos:"
                            },
                            {
                                "description": "Vários autores recomendam a avaliação neurológica seriada do paciente com trauma craniano a cada 30 - 60 minutos.",
                                "objects": [
                                    {
                                        "description": "Lembre-se que no momento inicial do atendimento é recomendável a estabilização do paciente crítico. "
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "A escala humana envolve a avaliação da capacidade verbal, avaliação dos reflexos do tronco encefálico e das respostas motoras."
                                    }
                                ],
                                "description": "A escala de Glasgow foi inicialmente utilizada em humanos com o intuito de avaliar pacientes com traumatismo craniano."
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Atividade Motora "
                                    },
                                    {
                                        "description": "Reflexos do Tronco Encefálico "
                                    },
                                    {
                                        "description": "Nível de Consciência "
                                    }
                                ],
                                "description": "A Escala Modificada de Glasgow para veterinária avalia os seguintes \"domínios\":"
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Permite a avaliação semi-objetiva (existe sim um grau de subjetividade entre avaliadores) do status neurológico do paciente."
                                    },
                                    {
                                        "description": "A escala permite que você clínico, consiga observar tendências de piora ou melhora do quadro clínico de forma simplificada."
                                    },
                                    {
                                        "description": "A padronização da escala, por mais que haja um grau de subjetividade, permite a publicação de artigos de maior inteligibilidade."
                                    },
                                    {
                                        "description": "Você consegue avaliar de forma mais palpável se intervenções terapêuticas estão deteriorando ou melhorando o quadro do paciente."
                                    }
                                ],
                                "description": "Qual a razão de utilizar a Escala Modificada de Glasgow para avaliar meus pacientes com trauma craniano?"
                            }
                        ],
                        "description": "Benefícios da Escala de Glasgow "
                    },
                    {
                        "description": "Desvantagens da Escala de Glasgow ",
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Diante disso, é mais importante avaliar tendências nos escores seriados do que um valor único isolado."
                                    }
                                ],
                                "description": "Existe um grau de subjetividade na escala, assim como há na maioria das escalas."
                            },
                            {
                                "objects": [],
                                "description": "O escore é ordinal e não linear, diante disso, mudanças no escore talvez não reflitam de forma acurada uma mudança de igual proporção do trauma/lesão neurológica subjacente."
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Lesões na medula espinhal podem afetar a avaliação correta da atividade motora."
                                    },
                                    {
                                        "description": "Lesões estritamente oculares podem levar à miose e atrapalhar a interpretação da avaliação dos reflexos do tronco encefálico."
                                    }
                                ],
                                "description": "O valor da Escala de Glasgow Modificada  pode ser influenciado por fatores não 100% correlacionados à lesão neurológica subjacente, citamos alguns exemplos:"
                            },
                            {
                                "description": "Alterações sistêmicas como hipovolemia, hipotensão, hipóxia, hipoglicemia e outros podem afetar o nível de consciência do paciente.",
                                "objects": []
                            },
                            {
                                "objects": [],
                                "description": "Alguns estudos que avaliaram a capacidade prognóstica da Escala de Glasgow Modificada, pautaram suas análises em dados retrospectivos (maior nível de viés) e consideraram pacientes eutanasiados (comumente o maior número de pacientes mortos) em suas análises como \"morte\", fator esse que pode influenciar o real valor prognóstico da escala. "
                            }
                        ]
                    },
                    {
                        "description": "Adendos ",
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Não se desanime quando o primeiro escore do paciente parecer desfavorável, lembre-se que o importante é a tendência de piora ou melhora do escore e não simplesmente a interpretação de um valor único isolado."
                                    }
                                ],
                                "description": "Cães e Gatos possuem uma incrível resiliência e capacidade de recuperação neurológica após traumas cranianos."
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Uma escala em voga é o ATT (Animal Trauma Triage), a mesma engloba mais sistemas em sua avaliação."
                                    }
                                ],
                                "description": "Além da Escala de Glasgow Modificada, existem outras escalas para avaliação do trauma cranioencefálico."
                            }
                        ]
                    }
                ],
                "description": "Objetivos da Escala de Glasgow Modificada"
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Atividade Motora"
                                    },
                                    {
                                        "description": "Reflexos do Tronco Encefálico"
                                    },
                                    {
                                        "description": "Nível de Consciência"
                                    }
                                ],
                                "description": "A Escala Modificada de Glasgow para veterinária avalia os seguintes \"domínios\":"
                            },
                            {
                                "description": "Como funciona os pontos da escala?",
                                "objects": [
                                    {
                                        "description": "A pontuação de cada domínio varia de 1 a 6."
                                    },
                                    {
                                        "description": "Os valores de cada domínio são somados, sendo o valor mais baixo possível o 3 e o valor mais alto o 18."
                                    }
                                ]
                            },
                            {
                                "description": "O que o valor somado quer dizer?",
                                "objects": [
                                    {
                                        "description": "Quanto mais próximo de 18 a soma for, melhor é o prognóstico do paciente."
                                    },
                                    {
                                        "description": "Quanto mais próximo de 3 a soma for, pior é o prognóstico do paciente."
                                    }
                                ]
                            }
                        ],
                        "description": "O que é avaliado"
                    },
                    {
                        "description": "A categoria da pontuação e sua relação com o prognóstico presumido",
                        "objects": [
                            {
                                "table": {
                                    "headers": [
                                        "Categoria da Pontuação",
                                        "Pontuação da Escala",
                                        "Prognóstico Sugerido"
                                    ],
                                    "caption": "Adaptado de: Platt SR, Radaelli ST, McDonnell JJ. The prognostic value of the modified Glasgow Coma Scale in head trauma in dogs. J Vet Intern Med. 2001",
                                    "lines": [
                                        {
                                            "Pontuação da Escala": "3 a 8",
                                            "Categoria da Pontuação": "I",
                                            "Prognóstico Sugerido": "Ruim"
                                        },
                                        {
                                            "Prognóstico Sugerido": "Reservado",
                                            "Categoria da Pontuação": "II",
                                            "Pontuação da Escala": "9 a 14"
                                        },
                                        {
                                            "Pontuação da Escala": "15 a 18",
                                            "Prognóstico Sugerido": "Bom",
                                            "Categoria da Pontuação": "III"
                                        }
                                    ]
                                },
                                "description": "A soma dos valores dos domínios pode se encaixar em 3 categorias.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "A Escala "
            },
            {
                "objects": [
                    {
                        "description": "Avaliação da Marcha",
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Normal "
                                    },
                                    {
                                        "description": "Hemiparesia ou tetraparesia"
                                    },
                                    {
                                        "description": "Decúbito."
                                    }
                                ],
                                "description": "A marcha pode ser descrita como:"
                            },
                            {
                                "description": "Lembre-se que os pacientes tendem a preservar algum nível de atividade motora, mesmo em estados de consciência alterada (exceção: pacientes comatosos).",
                                "objects": []
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Lembre-se que lesões na medula espinhal também podem levar à alteração na marcha do paciente."
                                    }
                                ],
                                "description": "A marcha alterada pode indicar uma lesão de tronco encefálico."
                            }
                        ]
                    },
                    {
                        "description": "Avaliação do Tônus Muscular ",
                        "objects": [
                            {
                                "description": "Aumento no tônus:",
                                "objects": [
                                    {
                                        "description": "Um aumento do tônus muscular pode ser visto em casos de trauma cranioencefálico, isso ocorre diante da perda da modulação inibitória sobre os neurônios motores inferiores."
                                    }
                                ]
                            },
                            {
                                "description": "Diminuição/perda do tônus:",
                                "objects": [
                                    {
                                        "description": "Trauma cranioencefálico grave pode levar à perda do tônus em todos os membros."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "description": "Avaliação dos Reflexos Espinhais ",
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Pacientes com trauma cranioencefálico comatosos podem apresentar completa arreflexia."
                                    }
                                ],
                                "description": "Pacientes com trauma cranioencefálico podem apresentar hiperreflexia. "
                            }
                        ]
                    },
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "A postura do paciente pode nos dar informações sobre o grau e lesão neurológica subjacente."
                            },
                            {
                                "description": "Rigidez por Descerebração:",
                                "objects": [
                                    {
                                        "description": "Hiperextensão dos quatro membros, acompanhado ou não de opistótono."
                                    },
                                    {
                                        "description": "Pacientes estuporosos ou comatosos com reflexos pupilares anormais."
                                    },
                                    {
                                        "description": "A presença dessa postura indica uma \"perda\" da comunicação entre o cérebro e o tronco encefálico."
                                    }
                                ]
                            },
                            {
                                "description": "Rigidez por Descerebelação ",
                                "objects": [
                                    {
                                        "description": "Opistótono com extensão dos membros torácicos e flexão dos quadris."
                                    },
                                    {
                                        "description": "A consciência tende a ser preservada."
                                    }
                                ]
                            }
                        ],
                        "description": "Postura "
                    }
                ],
                "description": "Os Domínios da Escala - Atividade Motora "
            },
            {
                "description": "Os Domínios da Escala - Reflexos do Tronco Encefálico ",
                "objects": [
                    {
                        "description": "Reflexo Pupilar Fotomotor ",
                        "objects": [
                            {
                                "description": "Um reflexo pupilar reativo à luz, nos indica que as seguintes estruturas estão minimamente preservadas:",
                                "objects": [
                                    {
                                        "description": "Retina."
                                    },
                                    {
                                        "description": "Nervos ópticos."
                                    },
                                    {
                                        "description": "Quiasma óptico. "
                                    },
                                    {
                                        "description": "Tronco encefálico rostral."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Possível lesão no diencéfalo."
                                    },
                                    {
                                        "description": "Fique atento: A inervação simpática pupilar pode ser corrompida ao longo do seu trajeto até o olho, não significando estritamente uma lesão no diencéfalo."
                                    },
                                    {
                                        "description": "Lesões oculares também podem levar à miose."
                                    }
                                ],
                                "description": "Miose:"
                            },
                            {
                                "description": "Midríase Bilateral irresponsiva à luz:",
                                "objects": [
                                    {
                                        "description": "Lesão mesencefálica ou hérnia cerebral."
                                    },
                                    {
                                        "description": "Fique atento: Baixa perfusão encefálica e trauma à iris ou retina também podem causar midríase."
                                    }
                                ]
                            },
                            {
                                "description": "Evolução de miose à midríase:",
                                "objects": [
                                    {
                                        "description": "A evolução do quadro clínico, bilateral comumente (pode ser unilateral no momento inicial), pode indicar uma piora do quadro clínico do paciente."
                                    }
                                ]
                            }
                        ],
                        "description": "Tamanho da Pupila"
                    },
                    {
                        "description": "Reflexo Oculocefálico ",
                        "objects": [
                            {
                                "objects": [
                                    {
                                        "description": "Possível lesão do tronco encefálico  e/ou lesões encefálicas."
                                    }
                                ],
                                "description": "Ausência/retardo do reflexo oculocefálico:"
                            }
                        ]
                    }
                ]
            },
            {
                "description": "Os Domínios da Escala -  Nível de Consciência ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "O nível de consciência do paciente reflete o status do córtex cerebral e do sistema ativador reticular ascendente (SARA) do tronco encefálico.",
                                "objects": []
                            }
                        ]
                    },
                    {
                        "objects": [
                            {
                                "description": "Normal | Alerta ",
                                "objects": [
                                    {
                                        "description": "O paciente responde adequadamente a estímulos."
                                    }
                                ]
                            },
                            {
                                "description": "Deprimido | Obnubilado ",
                                "objects": [
                                    {
                                        "description": "Resposta deprimida a estímulos, associada a uma sonolência despertável."
                                    },
                                    {
                                        "description": "Falta de atenção."
                                    }
                                ]
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Paciente se apresenta parcialmente ou completamente inconsciente, mas responde a estímulos nociceptivos."
                                    }
                                ],
                                "description": "Estuporoso "
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Paciente se apresenta completamente inconsciente e não responde a nenhum tipo de estímulo."
                                    }
                                ],
                                "description": "Comatoso "
                            },
                            {
                                "description": "Fique atento:",
                                "objects": [
                                    {
                                        "description": "Diversos fatores podem afetar o nível de consciência do paciente, considere a correção/ajuste dos mesmos e reavalie novamente o paciente."
                                    },
                                    {
                                        "description": "Fatores que podem afetar o nível de consciência: temperatura corporal, glicemia, pressão arterial, volemia, saturação de oxigênio dentre outros."
                                    }
                                ]
                            }
                        ],
                        "description": "Níveis de Consciência "
                    }
                ]
            }
        ],
        references: [
            {
                "link": "Não se aplica",
                "level": "Não se aplica",
                "year": "2020",
                "magazine": "Livro",
                "name": "Clinical Small Animal Internal Medicine, 1st Edition"
            },
            {
                "name": "Practical Guide to Canine and Feline Neurology, 3rd Edition",
                "level": "Não se aplica",
                "magazine": "Livro",
                "year": "2015",
                "link": "Não se aplica"
            },
            {
                "link": "Não se aplica",
                "magazine": "Livro",
                "level": "Não se aplica",
                "name": "A Practical Approach to Neurology for the Small Animal Practitioner",
                "year": "2020"
            },
            {
                "level": "4",
                "year": "2001",
                "magazine": "J Vet Intert Med.",
                "name": "The prognostic value of the modified Glasgow Coma Scale in head trauma in dogs",
                "link": "https://pubmed.ncbi.nlm.nih.gov/11817064/"
            },
            {
                "year": "2010",
                "link": "https://onlinelibrary.wiley.com/doi/full/10.1111/j.1939-1676.2010.0483.x",
                "level": "5",
                "name": "Illness Severity Scores in Veterinary Medicine: What Can We Learn?",
                "magazine": "J Vet Intern Med."
            },
            {
                "link": "https://pubmed.ncbi.nlm.nih.gov/29687940/",
                "name": "Performance evaluation and validation of the animal trauma triage score and modified Glasgow Coma Scale with suggested category adjustment in dogs: A VetCOT registry study",
                "year": "2018",
                "level": "3",
                "magazine": "J Vet Emerg Crit Care "
            },
            {
                "link": "https://pubmed.ncbi.nlm.nih.gov/26112259/",
                "name": "Retrospective evaluation of prognostic indicators in dogs with head trauma: 72 cases (January-March 2011)",
                "level": "4",
                "magazine": "J Vet Emerg Crit Care.",
                "year": "2015"
            }
        ]
    },
    /* #endregion */
    /* #region Conversão de Volume */
    {
        name: 'Conversão de Volume',
        id: '734b21eb3f964e0b83180645573e421a',
        classes: ['Calculadoras de Conversão'],
        variables: [
            {
                name: 'Selecione a medida de Volume Inicial',
                type: 'select',
                placeholder: 'Selecione',
                id: 'unit',
                items: [
                    'quilolitro (kL)',
                    'litro (L)',
                    'decilitros (dL)',
                    'mililitros (mL)',
                    'microlitros (ug)',
                ],
                default: null
            },
            {
                name: 'Digite o Volume Inicial',
                type: 'number',
                placeholder: 'Volume',
                id: 'volume',
                default: 0,
                displayUnit: 'unit'
            }
        ],
        calculate: function ({ unit, volume }) {
            volume = volume || '0';
            if (!unit) {
                return null;
            }
            volume = new BigNumber(volume.replace(',', '.'));
            const units = {
                'quilolitro (kL)': 1000,
                'litro (L)': 1,
                'decilitros (dL)': 0.1,
                'mililitros (mL)': 0.001,
                'microlitros (ug)': 0.000001
            };
            let response = [];
            for (const key in units) {
                let value = volume.times(units[unit]).dividedBy(units[key]);
                response.push(`${_formatNumber(value)} ${key}`);
            }
            return { type: 'array', values: response };
        },
        responseLabel: "Resultados",
        sections: [
            {
                "description": "Objetivos da Calculadora ",
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Calculadora utilizada com o intuito de converter diferentes unidades de medida de volume."
                            },
                            {
                                "description": "Basta selecionar a medida inicial de volume e digitar o valor desejado.",
                                "objects": [
                                    {
                                        "description": "Os resultados lhe mostrarão a conversão em diversas unidades de medida de volume, facilitando o seu dia a dia."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Conversão de unidades de medida de volume."
                            }
                        ]
                    }
                ],
                "description": "Indicações de Uso "
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Os resultados correspondem à conversão do valor digitado inicial."
                            }
                        ]
                    }
                ],
                "description": "Interpretação "
            }
        ],
        references: [
            {
                "magazine": "Livro",
                "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
                "level": "Não se aplica",
                "year": "2016",
                "link": "Não se aplica"
            },
            {
                "magazine": "Livro",
                "year": "2019",
                "link": "Não se aplica",
                "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition",
                "level": "Não se aplica"
            },
            {
                "year": "2019",
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "magazine": "Livro",
                "level": "Não se aplica",
                "link": "Não se aplica"
            }
        ]
    },
    /* #endregion */
    /* #region Conversão mcg/kg/minuto (mcg/kg/min) para mL/hora (mL/h) */
    {
        name: 'Conversão mcg/kg/minuto (mcg/kg/min) para mL/hora (mL/h)',
        id: '81059679b2c74b70919db32308e02903',
        classes: ['Calculadoras de Conversão'],
        variables: [
            {
                name: 'Taxa (mcg/kg/min)',
                type: 'number',
                placeholder: 'Taxa',
                id: 'rate',
                default: 0,
                suffix: '(mcg/kg/min)'
            },
            {
                name: 'Peso do Paciente (kg)',
                type: 'number',
                placeholder: 'Peso',
                id: 'weight',
                default: 0,
                suffix: '(kg)'
            },
            {
                name: 'Diluição da Solução (mg/mL)',
                type: 'number',
                placeholder: 'Diluição',
                id: 'dilution',
                default: 0,
                suffix: '(mg/mL)'
            }
        ],
        calculate: function ({ rate, weight, dilution }) {
            if (!rate || !weight || !dilution || dilution == '0') {
                return null;
            }
            weight = new Number(weight.replace(',', '.'));
            rate = new Number(rate.replace(',', '.'));
            dilution = new Number(dilution.replace(',', '.'));
            let response = (rate * weight) / (16.6666667 * dilution);
            response = _roundNumber(response, 2);
            return `${_formatNumber(response)} mL/hora`;
        },
        responseLabel: "Resultado",
        references: [
            {
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "year": "2019",
                "level": "Não se aplica",
                "magazine": "Livro",
                "link": "Não se aplica"
            }
        ],
        sections: [
            {
                "description": "Objetivo da Calculadora ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Converter taxas de infusão em mcg/kg/minuto para mL/hora.",
                                "objects": []
                            }
                        ]
                    }
                ]
            },
            {
                "description": "Indicações de Uso ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Algumas doses de medicamentos que serão administrados em taxas de infusão contínua, são comumente dispostas em mcg/kg/minuto.  ",
                                "objects": [
                                    {
                                        "description": "A conversão para mL/hora facilita a programação de bombas de infusão."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "O resultado final corresponde ao valor da taxa de infusão (dose) em mL/hora.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "Interpretação "
            }
        ]
    },
    /* #endregion */
    /* #region Lesão de Medula Espinhal – Escore Frankel Modificado */
    {
        name: 'Lesão de Medula Espinhal – Escore Frankel Modificado',
        id: '211a24f1904947f98bad9d57159afa05',
        classes: ['Escalas | Escores'],
        type: 'score',
        premium: true,
        variables: [],
        responseLabel: null,
        sections: [
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Grau 0: Tetraplegia ou paraplegia sem dor profunda."
                            },
                            {
                                "objects": [],
                                "description": "Grau 1: Tetraplegia ou paraplegia sem dor superficial."
                            },
                            {
                                "objects": [],
                                "description": "Grau 2: Tetraplegia ou paraplegia com nocicepção normal."
                            },
                            {
                                "objects": [],
                                "description": "Grau 3: Tetraparesia ou paraparesia não ambulatória."
                            },
                            {
                                "objects": [],
                                "description": "Grau 4: Tetraparesia ou paraparesia ambulatória e ataxia proprioceptiva."
                            },
                            {
                                "objects": [],
                                "description": "Grau 5: Hiperestesia espinhal, sem disfunções."
                            },
                        ]
                    }
                ],
                "description": "Escore Frankel Modificado"
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "O Escore de Frankel modificado é utilizado por alguns clínicos com o intuito de padronizar/normatizar os diferentes \"graus\" de lesão da medula espinhal.",
                                "objects": [
                                    {
                                        "description": "Essa padronização e normatização facilita a interpretação e comunicação de estudos clínicos de prognóstico e tratamento."
                                    }
                                ]
                            },
                            {
                                "description": "Atenção:",
                                "objects": [
                                    {
                                        "description": "O uso de escores \"crus\" sem detalhes na ficha clínica do paciente, pode levar a supressão de nuances clínicas significativas, recomenda-se que mesmo que se utilize o escore de Frankel, deve-se registrar detalhadamente o quadro clínico do paciente."
                                    },
                                    {
                                        "description": "No momento de registrar e comunicar o escore de Frankel, não se esqueça de deixar claro o nome do escore utilizado (Frankel), essa recomendação decorre do fato que alguns clínicos podem utilizar outros escores de classificação de lesão da medula espinhal."
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "description": "Objetivos "
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Escores mais próximos de 0 indicam lesões de maior gravidade e por conseguinte um pior prognóstico.",
                                "objects": []
                            },
                            {
                                "description": "Escores mais próximos de 5 indicam lesões menos graves e por conseguinte um prognóstico mais favorável.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "Interpretação "
            }
        ],
        references: [
            {
                "magazine": "Livro",
                "year": "2014",
                "name": "Kirk's Current Veterinary Therapy XV",
                "link": "Não se aplica",
                "level": "Não se aplica"
            },
            {
                "magazine": "Livro",
                "link": "Não se aplica",
                "year": "2017",
                "name": "Textbook of Veterinary Internal Medicine, 8th edition ",
                "level": "Não se aplica"
            },
            {
                "name": "\nDescription and repeatability of a newly developed spinal cord injury scale for dogs",
                "magazine": "Prev Vet Med.",
                "link": "https://pubmed.ncbi.nlm.nih.gov/19303151/",
                "year": "2009",
                "level": "3"
            }
        ],
        showAllSections: true
    },
    /* #endregion */
    /* #region Conversão de concentração */
    {
        name: 'Conversão de Concentrações',
        id: '41d8c9ff6f91483f869e895108167b97',
        classes: ['Calculadoras de Conversão'],
        variables: [
            {
                name: 'Selecione a medida inicial de Concentração',
                type: 'select',
                placeholder: 'Selecione',
                id: 'unit',
                items: [
                    'g/mL',
                    '%',
                    'mg/mL',
                    'mcg/mL',
                ],
                default: null
            },
            {
                name: 'Digite a Concentração Inicial',
                type: 'number',
                placeholder: 'Concentração',
                id: 'concentration',
                default: 0,
                displayUnit: 'unit'
            }
        ],
        calculate: function ({ unit, concentration }) {
            concentration = concentration || '0';
            concentration = new BigNumber(concentration.replace(',', '.'));
            if (!unit) {
                return null;
            }
            const units = {
                'g/mL': 1,
                '%': 0.01,
                'mg/mL': 0.001,
                'mcg/mL': 0.000001,
            };
            let response = [];
            for (const key in units) {
                let value = concentration.times(units[unit]).dividedBy(units[key]);
                value = _formatNumber(value);
                response.push(`[${key}] = ${value} ${key}`);
            }
            return { type: 'array', values: response };
        },
        responseLabel: "Resultados",
        sections: [
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Calculadora utilizada com o intuito de converter diferentes unidades de medida de concentração.",
                                "objects": []
                            },
                            {
                                "description": "Basta selecionar a medida inicial de concentração e digitar o valor desejado.",
                                "objects": [
                                    {
                                        "description": "Os resultados lhe mostrarão a conversão em diversas unidades de medida de concentração, facilitando o seu dia a dia."
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "description": "Objetivos da Calculadora "
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Conversão de unidades de medida de concentração."
                            }
                        ]
                    }
                ],
                "description": "Indicações de Uso "
            },
            {
                "description": "Interpretação ",
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Os resultados correspondem à conversão do valor digitado inicial."
                            }
                        ]
                    }
                ]
            }
        ],
        references: [
            {
                "level": "Não se aplica",
                "year": "2016",
                "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
                "link": "Não se aplica",
                "magazine": "Livro"
            },
            {
                "link": "Não se aplica",
                "level": "Não se aplica",
                "year": "2019",
                "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition",
                "magazine": "Livro"
            },
            {
                "link": "Não se aplica",
                "year": "2019",
                "magazine": "Livro",
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "level": "Não se aplica"
            }
        ]
    },
    /* #endregion */
    /* #region Conversão de mL/hora (mL/h) para mcg/kg/minuto (mcg/kg/min) */
    {
        name: 'Conversão de mL/hora (mL/h) para mcg/kg/minuto (mcg/kg/min)',
        id: 'b036000caa8044e1ba7d9b72c3ec266e',
        classes: ['Calculadoras de Conversão'],
        variables: [
            {
                name: 'Taxa (mL/h)',
                type: 'number',
                placeholder: 'Taxa',
                id: 'rate',
                default: 0,
                suffix: '(mL/h)'
            },
            {
                name: 'Concentração da Solução (mg/mL)',
                type: 'number',
                placeholder: 'Concentração',
                id: 'concentration',
                default: 0,
                suffix: '(mg/mL)'
            },
            {
                name: 'Peso do Paciente (kg)',
                type: 'number',
                placeholder: 'Peso',
                id: 'weight',
                default: 0,
                suffix: '(kg)'
            }
        ],
        calculate: function ({ rate, concentration, weight }) {
            if (!rate || !concentration || !weight || weight == 0) {
                return null;
            }
            weight = new Number(weight.replace(',', '.'));
            rate = new Number(rate.replace(',', '.'));
            concentration = new Number(concentration.replace(',', '.'));
            return `${((rate * concentration * 16.6666667) / weight)}`.replace(".", ",");
        },
        responseLabel: "Resultado (mcg/kg/min)",
        sections: [
            {
                "description": "Objetivo da Calculadora ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Converter taxas de infusão em mL/hora para mcg/kg/minuto.",
                                "objects": []
                            }
                        ]
                    }
                ]
            },
            {
                "description": "Indicações de Uso ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Algumas doses de medicamentos que serão administrados em taxas de infusão contínua, são comumente dispostas em mcg/kg/minuto.  ",
                                "objects": [
                                    {
                                        "description": "A conversão para mcg/kg/minuto facilita a inteligibilidade da dose utilizada e o ajuste da mesma."
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "description": "Interpretação ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "O resultado final corresponde ao valor da taxa de infusão (dose) em mcg/kg/minuto.",
                                "objects": []
                            }
                        ]
                    }
                ]
            }
        ],
        references: [
            {
                "link": "Não se aplica",
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "level": "Não se aplica",
                "year": "2019",
                "magazine": "Livro"
            }
        ]
    },
    /* #endregion */
    /* #region Diluição - Descobrir o Volume inicial */
    {
        name: 'Descobrir o Volume Inicial | <u><b>V1</b></u> X C1 = V2 X C2',
        id: 'a15975fb2ef44f7394acb96b780376cc',
        classes: ['Calculadoras de Diluição'],
        variables: [
            {
                name: 'Selecione a unidade de medida da [concentração] no frasco',
                type: 'select',
                placeholder: 'Selecione',
                id: 'initialConcentrationUnit',
                items: [
                    '%',
                    'mg/mL',
                    'mcg/mL',
                ],
                default: null
            },
            {
                name: 'Insira o valor da [concentração] inicial',
                type: 'number',
                placeholder: 'Concentração inicial',
                id: 'initialConcentration',
                default: 0,
                displayUnit: 'initialConcentrationUnit'
            },
            {
                name: 'Selecione a unidade de medida da [concentração] final desejada',
                type: 'select',
                placeholder: 'Selecione',
                id: 'finalConcentrationUnit',
                items: [
                    '%',
                    'mg/mL',
                    'mcg/mL',
                ],
                default: null
            },
            {
                name: 'Insira o valor da [concentração] final desejada',
                type: 'number',
                placeholder: 'Concentração final',
                id: 'finalConcentration',
                default: 0,
                displayUnit: 'finalConcentrationUnit'
            },
            {
                name: 'Insira o volume final desejado (mL)',
                type: 'number',
                placeholder: 'Volume Final',
                id: 'finalVolume',
                default: 0,
                suffix: 'mL'
            },
        ],
        calculate: function ({ initialConcentrationUnit, initialConcentration, finalConcentrationUnit, finalConcentration, finalVolume }) {
            if (!initialConcentrationUnit || !initialConcentration || !finalConcentrationUnit || !finalConcentration || !finalVolume) {
                return null;
            }
            const units = {
                '%': 0.01,
                'mg/mL': 0.001,
                'mcg/mL': 0.000001,
            };
            initialConcentration = new Number(initialConcentration.replace(',', '.'));
            finalConcentration = new Number(finalConcentration.replace(',', '.'));
            finalVolume = new Number(finalVolume.replace(',', '.'));
            initialConcentration = initialConcentration * units[initialConcentrationUnit];
            finalConcentration = finalConcentration * units[finalConcentrationUnit];
            if (initialConcentration == 0 || finalConcentration == 0) {
                return { type: 'error', description: 'Erro: as concentrações não podem ser iguais a zero.' };
            }
            if (initialConcentration <= finalConcentration) {
                return { type: 'error', description: 'Erro: a concentração final deve ser menor que a concentração incial.' };
            }
            let initialVolume = (finalVolume * finalConcentration) / initialConcentration;
            initialVolume = _roundNumber(initialVolume, 2);
            let residualVolume = finalVolume - initialVolume;
            initialVolume = `${_formatNumber(initialVolume)} mL`;
            residualVolume = _roundNumber(residualVolume, 2);
            residualVolume = `${_formatNumber(residualVolume)} mL`;
            return {
                type: 'multiple', values: [
                    { description: 'Volume inicial do Agente Concentrado:', value: initialVolume },
                    { description: 'Volume de diluente:', value: residualVolume }
                ]
            };
        },
        responseLabel: "Resultados",
        sections: [
            {
                "description": "Objetivos da Calculadora ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Em nosso dia a dia podemos enfrentar situações em que há a necessidade de prepararmos soluções diluídas, diante disso, precisamos calcular qual o volume da solução inicial concentrada para prepararmos a solução final na concentração e volume que desejamos.",
                                "objects": []
                            }
                        ]
                    }
                ]
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Diluir um medicamento concentrado, para que a concentração da solução final seja compatível com a administração endovenosa."
                            },
                            {
                                "description": "Preparar soluções de salina hipertônica a 7 - 7,5% quando há disponível apenas a apresentação comercial concentrada.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "Indicações de Uso "
            },
            {
                "description": "Interpretação dos Resultados ",
                "objects": [
                    {
                        "objects": []
                    },
                    {
                        "objects": [
                            {
                                "description": "Volume inicial do Agente Concentrado:",
                                "objects": [
                                    {
                                        "description": "Esse é o volume do medicamento/solução concentrada inicial que deve ser utilizado para que a sua solução final tenha a concentração e o volume final desejado."
                                    }
                                ]
                            },
                            {
                                "objects": [
                                    {
                                        "description": "Esse é o volume do agente diluente que deve ser adicionado ao volume inicial do agente concentrado para que a sua solução final tenha a concentração e o volume final desejado."
                                    }
                                ],
                                "description": "Volume de Diluente:"
                            }
                        ],
                        "description": "Os resultados serão dispostos em:"
                    }
                ]
            }
        ],
        references: [
            {
                "level": "Não se aplica",
                "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
                "link": "Não se aplica",
                "magazine": "Livro",
                "year": "2016"
            },
            {
                "magazine": "Livro",
                "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition",
                "level": "Não se aplica",
                "year": "2019",
                "link": "Não se aplica"
            },
            {
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "magazine": "Livro",
                "level": "Não se aplica",
                "year": "2019",
                "link": "Não se aplica"
            }
        ]
    },
    /* #endregion */
    /* #region Diluição - Descobrir a [] final */
    {
        name: 'Descobrir a [concentração] final | V1 X C1 = V2 X <u><b>C2</b></u>',
        id: 'c87ad07eec3d42619cea4204624823e6',
        classes: ['Calculadoras de Diluição'],
        variables: [
            {
                name: 'Selecione a unidade de medida da [concentração] no frasco',
                type: 'select',
                placeholder: 'Selecione a unidade de concentração',
                id: 'initialConcentrationUnit',
                items: [
                    '%',
                    'mg/mL',
                    'mcg/mL',
                ],
                default: null
            },
            {
                name: 'Insira o valor da [concentração]',
                type: 'number',
                placeholder: 'Concentração',
                id: 'initialConcentration',
                default: 0,
                displayUnit: 'initialConcentrationUnit'
            },
            {
                name: 'Volume inicial aspirado (mL)',
                type: 'number',
                placeholder: 'Volume inicial',
                id: 'initialVolume',
                default: 0,
                suffix: 'mL'
            },
            {
                name: 'Volume final total (mL)',
                type: 'number',
                placeholder: 'Volume final',
                id: 'finalVolume',
                default: 0,
                suffix: 'mL'
            },
            {
                name: 'Selecione a unidade de medida da [concentração] final',
                type: 'select',
                placeholder: 'Selecione a unidade de concentração',
                id: 'finalConcentrationUnit',
                items: [
                    '%',
                    'mg/mL',
                    'mcg/mL',
                ],
                default: null
            },
        ],
        calculate: function ({ initialConcentrationUnit, initialConcentration, finalConcentrationUnit, initialVolume, finalVolume }) {
            if (!initialConcentrationUnit || !initialConcentration || !finalConcentrationUnit || !initialVolume || !finalVolume) {
                return null;
            }
            const units = {
                '%': 0.01,
                'mg/mL': 0.001,
                'mcg/mL': 0.000001,
            };
            initialConcentration = new Number(initialConcentration.replace(',', '.'));
            initialVolume = new Number(initialVolume.replace(',', '.'));
            finalVolume = new Number(finalVolume.replace(',', '.'));

            if (initialVolume == 0 || finalVolume == 0) {
                return { type: 'error', description: 'Erro: os volumes não podem ser iguais a zero.' };
            }
            if (finalVolume <= initialVolume) {
                return { type: 'error', description: 'Erro: o volume final deve ser maior que o volume inicial.' };
            }
            let finalConcentration = (initialVolume * initialConcentration * units[initialConcentrationUnit]);
            finalConcentration = finalConcentration / (finalVolume * units[finalConcentrationUnit]);
            finalConcentration = _roundNumber(finalConcentration, 2);
            return `${_formatNumber(finalConcentration)}  ${finalConcentrationUnit}`;
        },
        responseLabel: "Resultado",
        sections: [
            {
                "description": "Objetivos da Calculadora ",
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Em nosso dia a dia podemos enfrentar situações em que há a necessidade de prepararmos soluções diluídas, diante disso, precisamos calcular qual a concentração final da solução após a diluição.",
                                "objects": []
                            }
                        ]
                    }
                ]
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Descobrir a concentração final da solução após a diluição."
                            }
                        ]
                    }
                ],
                "description": "Indicações de Uso "
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "O resultado indica qual a concentração final da solução, baseada nos parâmetros que você estabeleceu.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "Interpretação dos Resultados "
            }
        ],
        references: [
            {
                "magazine": "Livro",
                "link": "Não se aplica",
                "level": "Não se aplica",
                "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
                "year": "2016"
            },
            {
                "link": "Não se aplica",
                "year": "2019",
                "magazine": "Livro",
                "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition",
                "level": "Não se aplica"
            },
            {
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "link": "Não se aplica",
                "magazine": "Livro",
                "level": "Não se aplica",
                "year": "2019"
            }
        ]
    },
    /* #endregion */
    /* #region Diluição - Descobrir o Volume final */
    {
        name: 'Descobrir o Volume Final | V1 X C1 = <u><b>V2</b></u> X C2',
        id: 'db888214f5bc43f6b6d3ead15af154d4',
        classes: ['Calculadoras de Diluição'],
        variables: [
            {
                name: 'Selecione a unidade de medida da [concentração] no frasco',
                type: 'select',
                placeholder: 'Selecione',
                id: 'initialConcentrationUnit',
                items: [
                    '%',
                    'mg/mL',
                    'mcg/mL',
                ],
                default: null
            },
            {
                name: 'Insira o valor da [concentração] inicial',
                type: 'number',
                placeholder: 'Concentração inicial',
                id: 'initialConcentration',
                default: 0,
                displayUnit: 'initialConcentrationUnit'
            },
            {
                name: 'Insira o volume inicial aspirado (mL)',
                type: 'number',
                placeholder: 'Volume Inicial',
                id: 'initialVolume',
                default: 0,
                suffix: 'mL'
            },
            {
                name: 'Selecione a unidade de medida da [concentração] final diluída',
                type: 'select',
                placeholder: 'Selecione',
                id: 'finalConcentrationUnit',
                items: [
                    '%',
                    'mg/mL',
                    'mcg/mL',
                ],
                default: null
            },
            {
                name: 'Insira o valor da [concentração] diluída desejada',
                type: 'number',
                placeholder: 'Concentração final',
                id: 'finalConcentration',
                default: 0,
                displayUnit: 'finalConcentrationUnit'
            },

        ],
        calculate: function ({ initialConcentrationUnit, initialConcentration, finalConcentrationUnit, finalConcentration, initialVolume }) {
            if (!initialConcentrationUnit || !initialConcentration || !finalConcentrationUnit || !finalConcentration || !initialVolume) {
                return null;
            }
            const units = {
                '%': 0.01,
                'mg/mL': 0.001,
                'mcg/mL': 0.000001,
            };
            initialConcentration = new Number(initialConcentration.replace(',', '.'));
            initialConcentration = initialConcentration * units[initialConcentrationUnit];
            finalConcentration = new Number(finalConcentration.replace(',', '.'));
            finalConcentration = finalConcentration * units[finalConcentrationUnit];
            initialVolume = new Number(initialVolume.replace(',', '.'));

            if (initialConcentration == 0 || finalConcentration == 0) {
                return { type: 'error', description: 'Erro: as concentrações não podem ser iguais a zero.' };
            }
            if (initialConcentration <= finalConcentration) {
                return { type: 'error', description: 'Erro: a concentração final deve ser menor que a concentração incial.' };
            }
            let finalVolume = (initialVolume * initialConcentration);
            finalVolume = finalVolume / finalConcentration;
            let residualVolume = finalVolume - initialVolume;
            finalVolume = _formatNumber(_roundNumber(finalVolume, 2));
            residualVolume = _formatNumber(_roundNumber(residualVolume, 2));

            return {
                type: 'multiple', values: [
                    { description: 'Volume final total:', value: `${finalVolume} mL` },
                    { description: 'Volume de diluente:', value: `${residualVolume} mL` }
                ]
            };
        },
        responseLabel: "Resultados",
        sections: [
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "objects": [],
                                "description": "Em nosso dia a dia podemos enfrentar situações em que há a necessidade de prepararmos soluções diluídas, diante disso, precisamos calcular qual o volume da solução final para descobrirmos o quanto de diluente devemos adicionar à solução inicial."
                            }
                        ]
                    }
                ],
                "description": "Objetivos da Calculadora "
            },
            {
                "objects": [
                    {
                        "objects": [
                            {
                                "description": "Diluir um medicamento concentrado, para que a concentração da solução final seja compatível com a administração endovenosa.",
                                "objects": []
                            }
                        ]
                    }
                ],
                "description": "Indicações de Uso "
            },
            {
                "description": "Interpretação dos Resultados ",
                "objects": [
                    {
                        "objects": []
                    },
                    {
                        "objects": [
                            {
                                "description": "Volume final total:",
                                "objects": [
                                    {
                                        "description": "Esse será o volume final total da solução, para que ela tenha o valor da concentração diluída desejada diante do volume e concentração do agente inicial que você estabeleceu."
                                    }
                                ]
                            },
                            {
                                "description": "Volume de diluente:",
                                "objects": [
                                    {
                                        "description": "Esse é o volume do agente diluente que deve ser adicionado ao volume inicial do agente concentrado (que você estabeleceu), para que a sua solução final tenha a concentração final estabelecida por você."
                                    }
                                ]
                            }
                        ],
                        "description": "Os resultados serão dispostos em:"
                    }
                ]
            }
        ],
        references: [
            {
                "link": "Não se aplica",
                "magazine": "Livro",
                "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
                "year": "2016",
                "level": "Não se aplica"
            },
            {
                "magazine": "Livro",
                "link": "Não se aplica",
                "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition",
                "level": "Não se aplica",
                "year": "2019"
            },
            {
                "magazine": "Livro",
                "level": "Não se aplica",
                "year": "2019",
                "link": "Não se aplica",
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition"
            }
        ]
    },
    /* #endregion */
    /* #region Infusão Contínua */
    {
        name: 'Infusão Contínua',
        id: calculatorLabels.CONTINUOUS_INFUSION_ID,
        premium: true,
        classes: ['Calculadoras de Infusão'],
        routeName: 'continuous-infusion-calculator',
        sections: [],
        references: [
            {
                "level": "Não se aplica",
                "magazine": "Livro",
                "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
                "year": "2016",
                "link": "Não se aplica"
            },
            {
                "magazine": "Livro",
                "link": "Não se aplica",
                "year": "2019",
                "level": "Não se aplica",
                "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition"
            },
            {
                "magazine": "Livro",
                "year": "2019",
                "link": "Não se aplica",
                "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
                "level": "Não se aplica"
            },
            {
                "year": "2017",
                "magazine": "Livro",
                "level": "Não se aplica",
                "name": "Textbook of Veterinary Internal Medicine, 8th edition ",
                "link": "Não se aplica"
            }
        ]
    },
    /* #endregion */
]);